import { useEffect, useRef } from "react";

const getButtonLabel = (button: HTMLButtonElement, fallbackTitle: string) => {
  const ariaLabel = button.getAttribute("aria-label")?.trim();
  if (ariaLabel) return ariaLabel;

  const visibleText = button.textContent?.replace(/\s+/g, " ").trim();
  if (visibleText) return visibleText;

  return fallbackTitle;
};

export const useButtonTitles = (fallbackTitle: string) => {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const applyTitles = () => {
      root.querySelectorAll<HTMLButtonElement>("button").forEach((button) => {
        if (!button.hasAttribute("title")) {
          button.title = getButtonLabel(button, fallbackTitle);
        }
      });
    };

    applyTitles();
    const observer = new MutationObserver(applyTitles);
    observer.observe(root, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [fallbackTitle]);

  return rootRef;
};
